import * as yup from 'yup';

export const classifierFilesSchema = yup.object().shape({
  grupo: yup
    .string()
    .required('Grupo é obrigatório')
    .notOneOf([''], 'Grupo é obrigatório'),
  Descricao: yup
    .string()
    .required('Nome da regra é obrigatório')
    .test(
      'not-empty',
      'Nome da regra é obrigatório',
      (value) => value !== undefined && value !== null && value.trim() !== ''
    ),
  Data: yup
    .string()
    .required('Data da Vigência é obrigatória')
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida')
    .test('is-valid-date', 'Data inválida', function (value) {
      if (!value) return false;
      const date = new Date(value);
      return date instanceof Date && !isNaN(date.getTime());
    }),
  Regime: yup
    .string()
    .required('Regime Tributário é obrigatório')
    .notOneOf([''], 'Regime Tributário é obrigatório'),
  Remetente: yup
    .string()
    .required('Remetente é obrigatório')
    .notOneOf([''], 'Remetente é obrigatório'),
  UfOrigem: yup
    .string()
    .required('UF Origem é obrigatória')
    .notOneOf([''], 'UF Origem é obrigatória'),
  TipoNota: yup
    .string()
    .required('Identificador da Operação é obrigatório')
    .notOneOf([''], 'Identificador da Operação é obrigatório'),
  Natureza: yup
    .string()
    .required('Natureza da operação é obrigatória')
    .notOneOf([''], 'Natureza da operação é obrigatória'),
  Finalidade: yup
    .string()
    .required('Finalidade é obrigatória')
    .notOneOf([''], 'Finalidade é obrigatória'),
  Destinatario: yup
    .string()
    .required('Destinatário é obrigatório')
    .notOneOf([''], 'Destinatário é obrigatório'),
  UfDestino: yup
    .string()
    .required('UF Destino é obrigatória')
    .notOneOf([''], 'UF Destino é obrigatória'),
});

